import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'store'

export interface ImportProgressType {
    total?: number
    completed?: number
    errorItems?: string[]
}

const importExportSlice = createSlice({
    name: 'importExportSlice',
    initialState: {
        progress: {
            total: 1,
            completed: 0,
            errorItems: []
        } as ImportProgressType,
        isMinimizing: false,
    },
    reducers: {
        setProgress: (state, { payload }: PayloadAction<ImportProgressType>) => {
            state.progress = { ...state.progress, ...payload }
        },
        setIsMinimizing: (state, { payload }: PayloadAction<boolean>) => {
            state.isMinimizing = payload
        }
    },
})

export const { setProgress, setIsMinimizing } = importExportSlice.actions
export const progressSelector = (state: RootState) => state.importExport.progress
export const isMinimizingSelector = (state: RootState) => state.importExport.isMinimizing

export default importExportSlice.reducer
